import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  effect,
} from "@angular/core";
import { UserProfile } from "firebase/auth";
import { ProfileService } from "src/app/features/accounts/services/profile/profile-services.service";

@Directive({
  selector: "[appShowIfReadOnly]",
})
export class ShowIfReadOnlyDirective<T> {
  user: UserProfile;
  constructor(
    private profileService: ProfileService,
    private templateRef: TemplateRef<T>,
    private viewContainer: ViewContainerRef
  ) {
    effect(() => {
      const account = this.profileService.selectedAccount();
      if (account?.accountId != this.user?.accountId) {
        this.user = account;
        this.showFunction();
      }
    });
  }

  // ngOnInit() {
  //     this.user = this.profileService.selectedAccount();
  //     this.showFunction();
  // }

  showFunction() {
    const isTemplatePresent = this.viewContainer.length > 0;
    if (
      (this.user.myussUserRole === "Read Only" ||
      this.profileService.isAccountInActive()) && !isTemplatePresent
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
